export const colors = [
  "#8A5ED5",
  "#D7C8F1",
  "#5D3A9A",
  "#B691F5",
  "#3E2A62",
  "#C4C4C4",
];
